<script>

</script>
{#snippet purpleHeader(text)}
    <h2 class="text-3xl font-semibold" style="color: #4D2DB7;">{text}</h2>
{/snippet}

<div id="page3" class="space-y-2 text-center" style="color: #4D2DB7;">
            {@render purpleHeader("Your work is on hold.")}
            
            <div class="space-y-4x">
                <p>Thank you for participating in the VITAL study!</p>
            </div>
            
        </div>